import { initState } from './state'

export async function init(props) {
  initState(props)
  return (await import('./api')).loadAll()
}
